module.exports = __webpack_public_path__ + "img/penjaminan-umum.8517d160.jpg";